module.exports = __webpack_public_path__ + "static/story1-f8700e82dd5dd7723b4f0cee71773e3a.png";